import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

const getDefaultSelectedPassengerType = () => {
  return {
    minAge: 0,
    maxAge: 0,
    defaultMargin: null,
    cardControl: false,
    foreignUseBlocked: false,
    touristicAgencyOnly: false,
    endDate: null,
    affiliatedPassengerTypeIds: [],
    requiresNoSeat: false,
    messageOnSelect: false,
    onSelectTextTr: "",
    onSelectTextEn: "",
  };
};
export default {
  state: () => ({
    selectedPassengerType: getDefaultSelectedPassengerType(),
    passengerTypes: [],
  }),

  mutations: {
    setSelectedPassengerType(state, passengerType) {
      Vue.set(state, "selectedPassengerType", passengerType);
    },
    setPassengerTypes(state, passengerTypes) {
      Vue.set(state, "passengerTypes", passengerTypes);
    },
    setDefaultSelectedPassengerType(state) {
      Vue.set(state, "selectedPassengerType", getDefaultSelectedPassengerType());
    },
    setDefaultPassengerTypeModule(state) {
      Vue.set(state, "selectedPassengerType", getDefaultSelectedPassengerType());
      Vue.set(state, "passengerTypes", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createPassengerType: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/passenger-types/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPassengerTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/entity").then((response) => {
        context.commit("setPassengerTypes", response.data);
        return response.data;
      });
    },

    loadSaleablePassengerTypes: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getTmsServiceUrl + "/train/load-saleable-train-passenger-types", request.trains).then((response) => {
        return response.data;
      });
    },

    loadPublishedPassengerTypes: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/entity/published").then((response) => {
        return response.data;
      });
    },
    loadPublishedPassengerTypesFromTmsCdn: (context) => {
      return axios.get(context.getters.getTmsCdnServiceUrl + "/passenger-types.json").then((response) => {
        return response.data;
      });
    },

    loadPassengerTypeHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/passenger-types/history/search", request).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },

    loadSelectedPassengerTypeHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/history/" + request.id).then((response) => {
        return response.data;
      });
    },

    deletePassengerType: (context, passengerType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/passenger-types/entity/" + passengerType.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          passengerType.intents = intents;
          passengerType.intentId = response.data.id;
          return passengerType;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftPassengerType: (context, passengerType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/passenger-types/draft/" + passengerType.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishPassengerType: (context, passengerType) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/passenger-types/publish/" + passengerType.intentId)
        .then((response) => {
          if (response.data) {
            response.data.intentId = 0;
          }
          return response.data;
        })
        .catch((error) => {
          return error.response;
        });
    },

    loadPassengerType: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/entity/" + request.id).then((response) => {
        context.commit("setSelectedPassengerType", response.data);
      });
    },

    sendToApprovalPassengerType: (context, passengerType) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/sendToApproval/" + passengerType.intentId).then((response) => {
        if (passengerType.intents[0].type === "CREATE_PASSENGER_TYPE") {
          passengerType.intents[0].status = "WAITING_APPROVAL";
        } else if (passengerType.intents[0].type === "UPDATE_PASSENGER_TYPE") {
          passengerType.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    rejectPassengerType: (context, passengerType) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/reject/" + passengerType.intentId).then((response) => {
        if (passengerType.intents[0].type === "DELETE_PASSENGER_TYPE") {
          passengerType.intents = null;
          passengerType.intentId = 0;
        } else if (passengerType.intents[0].type === "CREATE_PASSENGER_TYPE") {
          passengerType.intents[0].status = "DRAFT";
        } else if (passengerType.intents[0].type === "UPDATE_PASSENGER_TYPE") {
          passengerType.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallPassengerType: (context, passengerType) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/recall/" + passengerType.intentId).then((response) => {
        helper.recallOrRejectEntity(passengerType, "passengerType");
        return response.data;
      });
    },

    cancelPassengerType: (context, passengerType) => {
      return axios.get(context.getters.getMcServiceUrl + "/passenger-types/cancel/" + passengerType.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedPassengerType: (state) => {
      return state.selectedPassengerType;
    },

    getPassengerTypes: (state) => {
      return state.passengerTypes;
    },
  },
};
